// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__33N4y","header":"MergedInvoice_header__3ZRXF"};